import Dialog from '@mui/material/Dialog';
import { Box, Button, Typography, useTheme, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getMobile } from 'state/reducers/ui.reducers';
import _ from 'lodash';

type props = {
	open: boolean;
	handleContinue?: any;
	handleCancel?: any;
	title?: string;
	subTitle?: string | object;
	continueLabel?: string;
	cancelLabel?: string;
};

export const WarningDialog = (props: props) => {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const isMobile = useAppSelector(getMobile);
	const subtext = () => {
		if (_.isObject(props.subTitle)) {
			return (
				<Stack>
					{_.keys(props.subTitle)?.map((key, index) => (
						<Stack direction="row" key={index} sx={{ direction: 'ltr' }}>
							<Typography variant="boldBody1">{t(key)} : </Typography>
							<Typography>{t(_.get(props.subTitle, key)) || _.get(props.subTitle, key)}</Typography>
						</Stack>
					))}
				</Stack>
			);
		}
		return props?.subTitle ? t(props.subTitle) : '';
	};
	return (
		<Dialog
			onClose={() => props.handleCancel && props.handleCancel}
			open={props.open && (props?.title || props?.subTitle) ? true : false}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			sx={{
				'& .MuiPaper-root': {
					[theme.breakpoints.down('sm')]: {
						margin: '16px',
						maxWidth: '100%',
						width: '100%',
					},
				},
			}}
		>
			<Box sx={{ textAlign: 'center', padding: '12px 12px 36px 12px' }}>
				<Stack spacing={4}>
					<Box sx={{ height: '40px' }}>
						{isMobile && (
							<Box
								sx={{
									background: theme.palette.root.darkGrayed_028,
									width: '40px',
									height: '40px',
									textAlign: 'center',
									float: 'right',
									borderRadius: '8px',
									cursor: 'pointer',
								}}
							>
								<CloseIcon
									onClick={props.handleCancel}
									sx={{ width: '20px', height: '40px', margin: 'auto' }}
								/>
							</Box>
						)}
					</Box>
					<Box
						sx={{
							width: '56px',
							margin: 'auto!important',
							height: '56px',
							backgroundColor: '#ffa600',
							boxShadow: '0 2px 8px 0 rgba(255, 166, 0, 0.32)',
							borderRadius: '100%',
							textAlign: 'center',
						}}
					>
						<PriorityHighIcon sx={{ color: '#fff', height: '56px', width: '20px' }} />
					</Box>
					<Stack spacing={0} sx={{ padding: '0 35px' }}>
						<Typography variant="h3" sx={{ [theme.breakpoints.up('sm')]: { padding: '0 60px' } }}>
							{props?.title}
						</Typography>
						<Typography variant="body3">{subtext()}</Typography>
					</Stack>
					{props.handleContinue && (
						<Stack gap={2} direction="row" justifyContent="center">
							<Button variant="outlined" onClick={props.handleCancel}>
								{props?.continueLabel}
							</Button>
							<Button variant="outlined" onClick={props.handleContinue} autoFocus>
								{props?.cancelLabel}
							</Button>
						</Stack>
					)}
					{!props.handleContinue && (
						<Button variant="outlined" onClick={props.handleCancel}>{`${t(
							'portal.actions.close'
						)}`}</Button>
					)}
				</Stack>
			</Box>
		</Dialog>
	);
};
